import { IUserCategoryBase, IVentureBase } from '../../models/ventures';
import { IUserBase } from '../../models/users';
import wbsBookingsApi from '../apis/wbsBookingsApi';
import { IFeatureGroupBase, IFeatureBase } from '../../models/features';

interface IDetailedUserHost extends IUserBase {
  category: IUserCategoryBase;
}

export interface IShowUserDetailedFeatureGroup extends IFeatureGroupBase {
  features: IFeatureBase[];
}

export interface IDetailedUser extends IUserBase {
  category?: IUserCategoryBase;
  featureGroup?: IShowUserDetailedFeatureGroup;
  host?: IDetailedUserHost;
  venture?: IVentureBase;
}

export const showUsersService = async (
  userId: string,
): Promise<IDetailedUser> => {
  const { data } = await wbsBookingsApi.get<IDetailedUser>(`/users/${userId}`);

  return data;
};
